export const billingKeys = {
	all: ['billing'],
	products: () => [...billingKeys.all, 'products'],
	prices: () => [...billingKeys.all, 'prices'],
	subscription: () => [...billingKeys.all, 'subscription'],
};
